// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__sanomatSans_e6648f', '__sanomatSans_Fallback_e6648f'"},"className":"__className_e6648f","variable":"__variable_e6648f"};